export const callSummary = [
    {
        id: 'calllist11',
        title: 'Inbound Calls',
        count: '50',
        increment: true,
        by: '10%'
    },
    {
        id: 'calllist12',
        title: 'Avg. CSAT',
        count: '50%',
        increment: true,
        by: '10%'
    },
    {
        id: 'calllist13',
        title: 'Avg. QA Score Calls',
        count: '50.77%',
        increment: true,
        by: '10%'
    },
    {
        id: 'calllist14',
        title: 'Avg. Nytro Rating',
        count: '4.7',
        rating: true,
        increment: true,
        by: '10%'
    },
    {
        id: 'calllist15',
        title: 'Appreciations',
        count: '50',
        increment: true,
        by: '10%'
    }
]

export const chatSummary = [
    {
        id: 'chatlist11',
        title: 'Chats Served',
        count: '50',
        increment: true,
        by: '10%'
    },
    {
        id: 'chatlist12',
        title: 'Avg. CSAT',
        count: '50%',
        increment: true,
        by: '10%'
    },
    {
        id: 'chatlist13',
        title: 'Avg. QA Score',
        count: '50.77%',
        increment: true,
        by: '10%'
    },
    {
        id: 'chatlist14',
        title: 'Avg. Nytro Rating',
        count: '4.7',
        rating: true,
        increment: true,
        by: '10%'
    },
    {
        id: 'chatlist15',
        title: 'Peak Concurrent Chats',
        count: '50',
        increment: true,
        by: '10%'
    },
    {
        id: 'chatlist16',
        title: 'Avg. Concurrent Chats',
        count: '50',
        increment: true,
        by: '10%'
    }
]